export default "__VITE_ASSET__CFI2xWGo__"